import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import prowerSetting from '@/components/power/prowerSetting';
import { devMonitorList, visualhistory, multiplehistory, projectinfo, deviceinfo } from "@/api/devicemon";
import Echarts from 'echarts';
import moment from 'moment';
import { mapGetters } from 'vuex';
export default {
  name: 'dataAnalysis',
  components: {
    prowerSetting: prowerSetting
  },
  data: function data() {
    return {
      deviceInfo: {
        devNumber: '',
        projectName: ''
      },
      query: {
        date: [moment().subtract(15, 'days').format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")],
        streamIds: ''
      },
      options: [],
      currentContent: 'chart',
      // 图表
      chartData: {},
      // 表格
      tableData: [],
      column: [{
        label: this.$t('dataAnalysis.time'),
        prop: 'time'
      }],
      // 图表分页
      chartDataList: [],
      // 储存查询过的图表数据
      currentChart: 0,
      // 当前图表索引
      chartCursor: '',
      // 表格分页
      tableDataList: [],
      // 储存查询过的tableData
      currentTable: 0,
      // 当前表格索引
      tableCursor: '',
      echartsUnit: '',
      tablename: ''
    };
  },
  computed: _objectSpread({}, mapGetters(["stationObj"])),
  created: function created() {},
  mounted: function mounted() {
    // this.getPage()
    this.getdevMonitorList();
    this.getDeviceinfo();
  },
  watch: {
    currentContent: {
      handler: function handler(newVal, oldVal) {
        if (newVal == 'chart') {
          this.$nextTick(function () {// this.getChart()
          });
        }
      },
      deep: true //true 深度监听

    }
  },
  methods: {
    init: function init() {
      this.query = {
        date: [],
        streamIds: ''
      };
      this.chartData = {}; // 表格

      this.tableData = [];
      this.column = [{
        label: this.$t('dataAnalysis.time'),
        prop: 'time'
      }]; // 图表分页

      this.chartDataList = []; // 储存查询过的图表数据

      this.currentChart = 0; // 当前图表索引

      this.chartCursor = ''; // 表格分页

      this.tableDataList = []; // 储存查询过的tableData

      this.currentTable = 0; // 当前表格索引

      this.tableCursor = '';
    },
    // 重置搜索
    reset: function reset() {
      this.init();
      this.getPage();
    },
    changesel: function changesel(val) {
      var a = this.options.filter(function (v) {
        return v.streamId === val;
      });

      if (a.length > 0) {
        this.echartsUnit = a[0].unit; //  this.tablename = a[0].monitorName
      }
    },
    // 获取默认设备信息
    getDeviceinfo: function getDeviceinfo() {
      var _this = this;

      projectinfo({
        id: this.stationObj.proid ? this.stationObj.proid : 0
      }).then(function (res) {
        if (res.status == 200) {
          _this.deviceInfo.projectName = res.data.data.projectName;
        }
      });
      deviceinfo({
        id: this.stationObj.devid ? this.stationObj.devid : 0
      }).then(function (res) {
        if (res.status == 200) {
          _this.deviceInfo.devNumber = res.data.data.devNumber;
        }
      });
    },
    // 表格
    getTableData: function getTableData() {
      var _this2 = this;

      var obj = {
        devCode: this.stationObj.devcode,
        streamIds: this.query.streamIds.toString(),
        beginTime: moment(this.query.date[0]).format('YYYY-MM-DDTHH:MM:SS'),
        onenetId: this.stationObj.onenetId,
        limit: 20
      };

      if (this.tableCursor) {
        obj.cursor = this.tableCursor;
      } else {
        obj.endTime = moment(this.query.date[1]).format('YYYY-MM-DDTHH:MM:SS');
      }

      visualhistory(obj).then(function (res) {
        _this2.tableData = [];
        _this2.column = [{
          label: _this2.$t('dataAnalysis.time'),
          prop: 'time'
        }];

        if (res.status == 200) {
          res.data.cursor ? _this2.tableCursor = res.data.cursor : _this2.tableCursor = '';
          res.data.categories && res.data.categories.map(function (item) {
            _this2.tableData.push({
              time: item
            });
          });
          res.data.series && res.data.series.map(function (item, index) {
            _this2.column.push({
              label: item.name,
              prop: "val".concat(index)
            });

            item.data.map(function (v, i) {
              if (_this2.tableData[i]) {
                _this2.tableData[i]["val".concat(index)] = v;
              }
            });
          });

          _this2.tableDataList.push(_this2.tableData);

          _this2.currentTable = _this2.tableDataList.length - 1;
        }
      });
    },
    // 图表
    getChartData: function getChartData() {
      var _this3 = this;

      // 历史数据
      var obj = {
        devCode: this.stationObj.devcode,
        streamIds: this.query.streamIds.toString(),
        beginTime: moment(this.query.date[0]).format('YYYY-MM-DDTHH:MM:SS'),
        onenetId: this.stationObj.onenetId,
        limit: 20
      };

      if (this.chartCursor) {
        obj.cursor = this.chartCursor;
      } else {
        obj.endTime = moment(this.query.date[1]).format('YYYY-MM-DDTHH:MM:SS');
      }

      visualhistory(obj).then(function (res) {
        _this3.chartData = {};

        if (res.status == 200) {
          // this.chartCursor = res?.data?.cursor
          res.data.cursor ? _this3.chartCursor = res.data.cursor : _this3.chartCursor = '';
          var arr = [];
          var arr1 = [];
          res.data.series && res.data.series.map(function (item, index) {
            var obj = [];
            item.data.map(function (v, i) {
              obj.push(Number(v));
            });
            arr1.push({
              type: 'line',
              name: item.name,
              data: obj
            });
            arr.push(item.name);
          });
          _this3.chartData = {
            lval: arr,
            xval: res.data.categories,
            yval: arr1
          };

          _this3.chartDataList.push(_this3.chartData);

          _this3.currentChart = _this3.chartDataList.length - 1;

          _this3.getChart(_this3.chartData);
        }
      });
    },
    getdevMonitorList: function getdevMonitorList() {
      var _this4 = this;

      devMonitorList({
        onenetId: this.stationObj.onenetId
      }).then(function (res) {
        if (res.data.code === 200) {
          _this4.options = res.data.data;

          if (res.data.data.length > 0) {
            _this4.query.streamIds = res.data.data[0].streamId;

            _this4.getPage();
          }
        }
      });
    },
    selectStation: function selectStation(data) {
      console.log(data);
      this.deviceInfo = {
        devNumber: data[0].devNumber,
        projectName: data[1].projectName
      };
    },
    switchContent: function switchContent(event) {
      this.currentContent = event.currentTarget.name; // if (this.currentContent == 'chart') {
      //   this.$nextTick(()=>{
      //     this.getChart()
      //   })
      // }
    },
    getPage: function getPage() {
      this.chartCursor = '';
      this.chartData = {};
      this.chartDataList = [];
      this.currentChart = 0;
      this.getChartData();
      this.getTableData(); // console.log(moment(this.query.date[0]).format('YYYY-MM-DDTHH:MM:SS'))
    },
    getChart: function getChart(chartData) {
      var chart = Echarts.init(document.getElementById('chart'));
      chart.clear();
      var option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#FFFFFF',
          padding: 10,
          textStyle: {
            color: '#000000'
          },
          extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);',
          transitionDuration: 0
        },
        color: ['#319CFF', '#62D183'],
        legend: {
          data: chartData.lval,
          icon: 'rect'
        },
        grid: {
          // containLabel: true,
          // bottom: '-0.5%',
          x: 50
        },
        toolbox: {
          feature: {// saveAsImage: {}
          }
        },
        dataZoom: [{
          type: 'slider',
          //slider表示有滑动块的，inside表示内置的
          show: true,
          xAxisIndex: [0],
          start: 0,
          end: 100
        }],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: chartData.xval
        },
        yAxis: {
          // show: false,
          name: "".concat(this.$t('dataAnalysis.unit'), " / ").concat(this.echartsUnit),
          axisLine: {
            show: false //不显示坐标轴线

          },
          type: 'value'
        },
        series: chartData.yval
      };
      chart.setOption(option, window.onresize = chart.resize);
    },
    // 图表上一页
    prevChartPage: function prevChartPage() {
      // console.log(this.currentChart)
      if (this.currentChart == 0) {
        this.$message.warning(this.$t('dataAnalysis.alFirstPage'));
      } else {
        this.currentChart -= 1;
        this.chartData = this.chartDataList[this.currentChart];
        this.getChart(this.chartData);
      }
    },
    // 图表下一页
    nextChartPage: function nextChartPage() {
      if (this.currentChart == this.chartDataList.length - 1 && this.chartCursor) {
        this.getChartData();
      } else if (this.currentChart == this.chartDataList.length - 1 && this.chartCursor == '') {
        this.$message.warning(this.$t('dataAnalysis.alLastPage'));
      } else {
        this.currentChart += 1;
        this.chartData = this.chartDataList[this.currentChart];
        this.getChart(this.chartData);
      }
    },
    // 表格上一页
    prevTablePage: function prevTablePage() {
      // console.log(this.currentTable)
      if (this.currentTable == 0) {
        this.$message.warning(this.$t('dataAnalysis.alFirstPage'));
      } else {
        this.currentTable -= 1;
        this.tableData = this.tableDataList[this.currentTable];
      }
    },
    // 表格下一页
    nextTablePage: function nextTablePage() {
      if (this.currentTable == this.tableDataList.length - 1 && this.tableCursor) {
        this.getTableData();
      } else if (this.currentTable >= this.tableDataList.length - 1 && this.tableCursor == '') {
        this.$message.warning(this.$t('dataAnalysis.alLastPage'));
      } else {
        this.currentTable += 1;
        this.tableData = this.tableDataList[this.currentTable];
      }
    },
    // 导出
    download: function download() {
      console.log('download');
    }
  }
};